import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";
import { Heart } from "lucide-react";

export default function SuccessStories() {
  const { language } = useLanguage();

  const contentEn = (
    <div className="space-y-8">
      <p className="text-muted-foreground">Read how happy couples found their dream partner and started their forever journey on Hamarsathi.</p>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div className="card-soft p-6 bg-white border border-border/40">
          <div className="flex items-center gap-2 mb-4 text-secondary">
            <Heart className="w-5 h-5 fill-current" />
            <span className="font-semibold text-foreground">Priya &amp; Abhishek (Ranchi)</span>
          </div>
          <p className="text-sm text-muted-foreground italic">
            "We found each other through Hamarsathi's district search. Since both of our families are from Ranchi, arranging meetings and matching details was seamless. Thank you for this wonderful platform!"
          </p>
        </div>

        <div className="card-soft p-6 bg-white border border-border/40">
          <div className="flex items-center gap-2 mb-4 text-secondary">
            <Heart className="w-5 h-5 fill-current" />
            <span className="font-semibold text-foreground">Sunita &amp; Rohan (Jamshedpur)</span>
          </div>
          <p className="text-sm text-muted-foreground italic">
            "The free Kundli Matching feature helped us calculate compatibility instantly. Our families were extremely happy with the scoring and verification checks. Highly recommended!"
          </p>
        </div>
      </div>
    </div>
  );

  const contentHi = (
    <div className="space-y-8">
      <p className="text-muted-foreground">पढ़ें कि कैसे खुशहाल जोड़ों ने अपना सपनों का जीवनसाथी पाया और हमरसाथी पर अपनी खुशहाल वैवाहिक यात्रा शुरू की।</p>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div className="card-soft p-6 bg-white border border-border/40">
          <div className="flex items-center gap-2 mb-4 text-secondary">
            <Heart className="w-5 h-5 fill-current" />
            <span className="font-semibold text-foreground">प्रिया और अभिषेक (रांची)</span>
          </div>
          <p className="text-sm text-muted-foreground italic">
            "हमने हमरसाथी के जिला खोज द्वारा एक-दूसरे को पाया। चूंकि हमारे दोनों परिवार रांची से हैं, इसलिए बैठकें आयोजित करना और विवरणों का मिलान करना बेहद आसान था। इस अद्भुत मंच के लिए धन्यवाद!"
          </p>
        </div>

        <div className="card-soft p-6 bg-white border border-border/40">
          <div className="flex items-center gap-2 mb-4 text-secondary">
            <Heart className="w-5 h-5 fill-current" />
            <span className="font-semibold text-foreground">सुनीता और रोहन (जमशेदपुर)</span>
          </div>
          <p className="text-sm text-muted-foreground italic">
            "मुफ्त कुंडली मिलान सुविधा ने हमें तुरंत अनुकूलता स्कोरिंग की गणना करने में मदद की। हमारे परिवार सत्यापन और विश्वसनीयता जांच से बेहद खुश थे।"
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <StaticPageLayout
      title={language === "hi" ? "सफलता की कहानियां" : "Success Stories"}
      subtitle={language === "hi" ? "हमरसाथी पर बने खुशहाल जोड़ों की कहानियां" : "Stories of happy couples who met on Hamarsathi"}
    >
      {language === "hi" ? contentHi : contentEn}
    </StaticPageLayout>
  );
}
